import { render, staticRenderFns } from "./PoliciesIndex.vue?vue&type=template&id=b1c66b6e"
import script from "./PoliciesIndex.vue?vue&type=script&lang=js"
export * from "./PoliciesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c66b6e')) {
      api.createRecord('b1c66b6e', component.options)
    } else {
      api.reload('b1c66b6e', component.options)
    }
    module.hot.accept("./PoliciesIndex.vue?vue&type=template&id=b1c66b6e", function () {
      api.rerender('b1c66b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/cancellation/PoliciesIndex.vue"
export default component.exports